<template>
  <el-dialog
    :title="'选择所属科室'"
    :visible.sync="open"
    :center="true"
    width="513px"
    @close="cancel"
    :close-on-click-modal="false"
  >
    <div>
      <el-input
        v-model="keyWord"
        suffix-icon="el-icon-search"
        @change="inputChange"
        placeholder="输入编号/关键字搜索科室"
        clearable
      ></el-input>
    </div>
    <div class="select-dialog">
      <div
        class="left-div border1-right"
        :class="{ width100: !showRight, width50: showRight }"
      >
        <el-tree
          :data="leftData"
          ref="my_tree"
          :props="defaultProps"
          show-checkbox
          check-strictly
          @check-change="handleNodeClick"
          check-on-click-node
          accordion
          node-key="id"
          :render-content="renderContent"
          :default-checked-keys="defaultCheckedKeys"
        ></el-tree>
      </div>
      <div v-if="showRight" class="right-div">
        <template v-for="(item, index) in rightData">
          <div v-if="index == 0" :key="index" style="display: flex;">
            <div class="main-item" style="">
              {{ item.no + " " + item.name }}
            </div>
            <div class="main-sign" style="">主要科室</div>
          </div>
          <div v-else :key="index" style="display: flex;">
            <div style="width:95%">{{ item.no + " " + item.name }}</div>
            <i
              class="el-icon-top icon-top"
              
              v-preventReClick
            @click="changeMainItem(item)"
            />
          </div>
        </template>
      </div>
    </div>
    <div class="selected-div">
      <template v-for="item in rightData">
        <div :key="item.id" class="value">
          <span
            >{{ item.no + " " + item.name + " " }}
            <i
              class="el-icon-close"
              style="cursor: pointer;"
              
              v-preventReClick
            @click="removeItem(item)"
            />
          </span>
        </div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn" size="small"  v-preventReClick
            @click="cancel"
        >取 消</el-button
      >
      <el-button
        class="btn primary"
        type="primary"
        size="small"
        
        v-preventReClick
            @click="submit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "myCheckBox",
  data() {
    return {
      rightData: [],
      open: false,
      keyWord: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultCheckedKeys: [],
    };
  },
  props: {
    leftData: {
      type: Array,
      default() {
        return [];
      },
    },
    oldData: {
      type: Array,
      default() {
        return [];
      },
    },
    mainDeptId: {
      type: Number,
      default() {
        return 0;
      },
    },
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showRight: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  watch: {
    show(val, oldVal) {
      this.open = val;
      this.rightData = JSON.parse(JSON.stringify(this.oldData));
      if (!this.rightData) {
        this.rightData = [];
      }
      this.defaultCheckedKeys = this.rightData.map((e) => e.id);
      this.$nextTick(() => {
        this.$refs["my_tree"].setCheckedKeys(this.defaultCheckedKeys);
      });
    },
  },
  methods: {
    renderContent(h, { node, data, store }) {
      return (
        // <el-tooltip class="item" effect="dark" placement="bottom-start">
        // <div slot="content">{data.no + ' ' + data.name}</div>
        <span class="custom-tree-node" style="overflow:hidden;">
          <span>{data.no + " " + data.name}</span>
        </span>
        // </el-tooltip>
      );
    },
    handleNodeClick(node, state) {
      if (state) {
        this.rightData.push(node);
      } else {
        this.rightData = this.rightData.filter((i) => i.id != node.id);
      }
    },
    cancel() {
      this.open = false;
      this.$refs["my_tree"].setCheckedKeys([]);
      this.$emit("close");
    },
    submit() {
      this.open = false;
      this.$emit("getData", this.rightData);
    },
    changeMainItem(data) {
      this.rightData = this.rightData.filter((i) => i.id != data.id);
      this.rightData.splice(0, 0, data);
    },
    removeItem(data) {
      this.rightData = this.rightData.filter((i) => i.id != data.id);
    },
    inputChange(val) {
      this.$emit("filterMethod", val);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
.left-div {
  max-height: 230px;

}
</style>
